import { useState } from "react";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

import {
  IAuthModalInput,
  IAuthModalInputMask,
} from "shared/components/organisms/AuthModal/types";

import { AuthModalInput, AuthModalInputWithMask } from "./Root";

export const AuthModalEmailInput = ({ ...props }: IAuthModalInput) => (
  <AuthModalInput
    autoComplete="off"
    label="Email"
    placeholder="Digite o seu email"
    type="email"
    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
    data-testid="auth-modal-email-input"
    required
    {...props}
  />
);

const PasswordIcon = () => {
  const [passwordIsHidden, setPasswordIsHidden] = useState(true);

  const handleChangePasswordViewMode = () => {
    setPasswordIsHidden(!passwordIsHidden);
  };

  return {
    passwordIsHidden,
    Icon: () => (
      <span className="auth-modal-input-options">
        {passwordIsHidden ? (
          <AiOutlineEyeInvisible
            className="eye-password"
            onClick={handleChangePasswordViewMode}
          />
        ) : (
          <AiOutlineEye
            className="eye-password"
            onClick={handleChangePasswordViewMode}
          />
        )}
      </span>
    ),
  };
};

export const AuthModalPasswordInput = ({ ...props }: IAuthModalInput) => {
  const { Icon, passwordIsHidden } = PasswordIcon();

  return (
    <AuthModalInput
      label="Senha"
      autoComplete="off"
      type={passwordIsHidden ? "password" : "text"}
      placeholder="Digite a sua senha"
      pattern="^.{6,}$"
      data-testid="auth-modal-password-input"
      Icon={Icon}
      required
      {...props}
    />
  );
};

export const AuthModalDefaultInput = ({ label, ...props }: IAuthModalInput) => {
  return (
    <AuthModalInput label={label} autoComplete="off" type="text" {...props} />
  );
};

export const AuthModalInputMask = ({
  label,
  ...props
}: IAuthModalInputMask) => {
  return (
    <AuthModalInputWithMask
      label={label}
      autoComplete="off"
      type="text"
      {...props}
    />
  );
};
